enum TicketStatus {
  OPEN = 'Open',
  CLOSED = 'Closed',
}

export default TicketStatus;
